import { OutlinedInput, OutlinedInputProps } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { onlyDigits } from '@functions/brazil-documents';

type Props = Omit<OutlinedInputProps, 'name' | 'value' | 'onChange' | 'onBlur'> & {
    name: string;
    mask: (value: string) => string;
    maxDigits: number;
    /// Recebe os dígitos no blur, onde ocorre a consulta de CEP/CNPJ (não a cada tecla).
    onBlurDigits?: (digits: string) => void;
};

/// Guarda só dígitos e exibe mascarado: a máscara é da tela, o servidor grava os dígitos.
export const MaskedField = ({ name, mask, maxDigits, onBlurDigits, ...props }: Props) => {
    const { control } = useFormContext();

    return (
        <Controller
            control={control}
            name={name}
            render={({ field }) => (
                <OutlinedInput
                    {...props}
                    value={mask(field.value ?? '')}
                    onChange={(event) =>
                        field.onChange(onlyDigits(event.target.value).slice(0, maxDigits))}
                    onBlur={() => {
                        field.onBlur();
                        onBlurDigits?.(onlyDigits(field.value));
                    }}
                    inputProps={{ inputMode: 'numeric' }}
                />
            )}
        />
    );
};
